function asNumber(value, fallback = 0) {
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
}

export default function ProcurementOrderLinesTable({
  lines = [],
  editable = false,
  onChange,
}) {
  const total = lines.reduce((sum, line) => {
    const qty = asNumber(line.quantity, 1);
    const price = asNumber(line.unitPrice, 0);
    return sum + qty * price;
  }, 0);

  const setField = (index, key, value) => {
    if (!editable || typeof onChange !== "function") return;
    const next = lines.map((line, idx) => (idx === index ? { ...line, [key]: value } : line));
    onChange(next);
  };

  const addLine = () => {
    if (!editable || typeof onChange !== "function") return;
    onChange([
      ...lines,
      { articleCode: "", description: "", quantity: 1, unit: "st", unitPrice: 0, notes: "" },
    ]);
  };

  const removeLine = (index) => {
    if (!editable || typeof onChange !== "function") return;
    onChange(lines.filter((_, idx) => idx !== index));
  };

  return (
    <div className="space-y-3">
      <div className="overflow-x-auto rounded-xl border border-slate-200">
        <table className="min-w-full divide-y divide-slate-200 text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-3 py-2">Artikel</th>
              <th className="px-3 py-2">Omschrijving</th>
              <th className="px-3 py-2">Aantal</th>
              <th className="px-3 py-2">Eenheid</th>
              <th className="px-3 py-2">Prijs</th>
              <th className="px-3 py-2">Totaal</th>
              {editable && <th className="px-3 py-2">Actie</th>}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 bg-white">
            {lines.length === 0 && (
              <tr>
                <td className="px-3 py-3 text-slate-500" colSpan={editable ? 7 : 6}>
                  Geen orderregels.
                </td>
              </tr>
            )}
            {lines.map((line, index) => {
              const qty = asNumber(line.quantity, 1);
              const price = asNumber(line.unitPrice, 0);
              const lineTotal = qty * price;
              return (
                <tr key={`line-${index}`}>
                  <td className="px-3 py-2">
                    {editable ? (
                      <input
                        value={line.articleCode || ""}
                        onChange={(e) => setField(index, "articleCode", e.target.value)}
                        className="w-full rounded border border-slate-200 px-2 py-1"
                      />
                    ) : (line.articleCode || "-")}
                  </td>
                  <td className="px-3 py-2">
                    {editable ? (
                      <input
                        value={line.description || ""}
                        onChange={(e) => setField(index, "description", e.target.value)}
                        className="w-full rounded border border-slate-200 px-2 py-1"
                      />
                    ) : (line.description || "-")}
                  </td>
                  <td className="px-3 py-2">
                    {editable ? (
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={line.quantity ?? 1}
                        onChange={(e) => setField(index, "quantity", e.target.value)}
                        className="w-24 rounded border border-slate-200 px-2 py-1"
                      />
                    ) : qty}
                  </td>
                  <td className="px-3 py-2">
                    {editable ? (
                      <input
                        value={line.unit || ""}
                        onChange={(e) => setField(index, "unit", e.target.value)}
                        className="w-20 rounded border border-slate-200 px-2 py-1"
                      />
                    ) : (line.unit || "-")}
                  </td>
                  <td className="px-3 py-2">
                    {editable ? (
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={line.unitPrice ?? 0}
                        onChange={(e) => setField(index, "unitPrice", e.target.value)}
                        className="w-28 rounded border border-slate-200 px-2 py-1"
                      />
                    ) : `€ ${price.toFixed(2)}`}
                  </td>
                  <td className="px-3 py-2 font-medium text-slate-700">€ {lineTotal.toFixed(2)}</td>
                  {editable && (
                    <td className="px-3 py-2">
                      <button type="button" onClick={() => removeLine(index)} className="text-xs text-rose-600 hover:text-rose-700">
                        Verwijderen
                      </button>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="flex items-center justify-between">
        <div className="text-sm text-slate-600">Subtotaal: <span className="font-semibold text-slate-900">€ {total.toFixed(2)}</span></div>
        {editable && (
          <button type="button" onClick={addLine} className="rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-xs text-slate-700 hover:bg-slate-50">
            Regel toevoegen
          </button>
        )}
      </div>
    </div>
  );
}
